module.exports = __webpack_public_path__ + "static/media/kick-deep.aac7e466.wav";